module.exports = __webpack_public_path__ + "static/media/bg-6.9fa87c67.jpg";